export enum Language {
  ENGLISH = 'en',
  GERMAN = 'de',
  FRENCH = 'fr',
  SPANISH = 'es',
  PORTUGUESE = 'pt',
  ITALIAN = 'it',
}
